import script from "./headLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./headLogin.vue?vue&type=script&setup=true&lang=js"

import "./headLogin.vue?vue&type=style&index=0&id=bd126c40&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd126c40"]])

export default __exports__